import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.locale("en-gb");
dayjs.extend(advancedFormat);

export default dayjs;
